import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import clsx from 'clsx';
import React from 'react';
import { useTranslation } from 'react-i18next';

interface DialogCloseButtonProps {
  onClose: () => void;
  className?: string;
  style?: React.CSSProperties;
}

const DialogCloseButton: React.FC<DialogCloseButtonProps> = ({ onClose, className, style }) => {
  const { t } = useTranslation();

  return (
    <IconButton
      aria-label={t('basic.actions.close')}
      color="inherit"
      size="small"
      onClick={() => onClose()}
      className={clsx('ml-auto', className)}
      style={style}
    >
      <CloseIcon />
    </IconButton>
  );
};

export default DialogCloseButton;
